<template>
  <a-form ref="formRef" :model="dataForm">
    <dc-layout-card title="基础信息" :span="6">
      <dc-form-item label="辅导人" name="mentor" :rules="[{ required: true, message: '请输入' }]">
        <UserSelect
          permission
          :disabled="true"
          v-model:value="dataForm.mentor"
          defaultValue="me"
          @change="handleMentorChange"
          :view="view"
        />
      </dc-form-item>
      <dc-form-item label="辅导人区域">
        <CustomerAreaCascader appId="cos_lbu" v-model:value="dataForm.mentorRegion" :disabled="true" :view="view" />
      </dc-form-item>
      <dc-form-item label="本次辅导时间" :rules="[{ required: true, message: '请选择' }]">
        <CosSingleDateTimePicker
          v-model:startTime="dataForm.tutoringTime"
          defaultValue="now"
          :isRange="false"
          :view="view"
        />
      </dc-form-item>
      <dc-form-item label="下次辅导时间" name="nextTutoringTime" :rules="[{ required: true, message: '请输入' }]">
        <CosSingleDateTimePicker v-model:startTime="dataForm.nextTutoringTime" :isRange="false" :view="view" />
      </dc-form-item>
      <dc-form-item label="被辅导人" name="trainee" :rules="[{ required: true, message: '请输入' }]">
        <UserSelect permission v-model:value="dataForm.trainee" @change="handleTraineeChange" :view="view" />
      </dc-form-item>
      <dc-form-item label="被辅导人区域">
        <CustomerAreaCascader appId="cos_lbu" v-model:value="dataForm.traineeRegion" :disabled="true" :view="view" />
      </dc-form-item>
    </dc-layout-card>

    <dc-layout-card title="辅导信息" :span="6">
      <dc-form-item label="客户名称" name="cosId" :rules="[{ required: true, message: '请选择' }]">
        <ClueAndCustomerSelect
          appId="cos_lbu"
          v-model:value="dataForm.cosId"
          v-model:label="dataForm.customerName"
          :view="view"
          @change="handleCustomerNameChange"
        />
      </dc-form-item>

      <dc-form-item label="跟进记录" name="followId" :rules="[{ required: true, message: '请选择' }]">
        <CosSelect
          v-model:value="dataForm.followId"
          :fieldNames="{ label: 'startTime', value: 'id' }"
          :options="followList"
          allowClear
          placeholder="请选择"
          @change="changeFollow"
          @click="handleFollowClick"
          style="cursor: pointer; color: blue;"
          :view="view"
        />
      </dc-form-item>
      <dc-form-item label="跟进方式" name="followMode">
        <CosInput
          v-model:value.trim="selectedFollow.followMode"
          :maxlength="200"
          :disabled="true"
          placeholder="自动带出"
          :view="view"
        />
      </dc-form-item>
      <dc-form-item label="联系人" name="contactName">
        <CosInput
          v-model:value.trim="selectedFollow.contactName"
          :maxlength="200"
          :disabled="true"
          placeholder="自动带出"
          :view="view"
        />
      </dc-form-item>
      <dc-form-item
        :span="12"
        label="本阶段重点关注和提升的技能"
        name="keyFocus"
        :rules="[{ required: true, message: '请输入' }]"
      >
        <CosTextarea :maxlength="2000" placeholder="请输入" v-model:value="dataForm.keyFocus" :view="view" />
      </dc-form-item>
      <dc-form-item
        :span="12"
        label="本次拜访的亮点和需要提升"
        name="visitHlt"
        :rules="[{ required: true, message: '请输入' }]"
      >
        <CosTextarea :maxlength="2000" placeholder="请输入" v-model:value="dataForm.visitHlt" :view="view" />
      </dc-form-item>
      <dc-form-item :span="12" label="后续计划" name="subPlans" :rules="[{ required: true, message: '请输入' }]">
        <CosTextarea :maxlength="2000" placeholder="请输入" v-model:value="dataForm.subPlans" :view="view" />
      </dc-form-item>
      <dc-form-item label="附件上传" name="fileId" :span="24">
        <UploadFile v-model:value="dataForm.fileId" valueType="array" :view="view" />
      </dc-form-item>
      <dc-form-item label="抄送人" name="ccTo">
        <UserSelect permission v-model:value="dataForm.ccTo" mode="multiple" :view="view" />
      </dc-form-item>
    </dc-layout-card>

    <!-- <dc-layout-card title="当前进度状态" :span="6">
      <dc-form-item :span="12" label="指标数据" name="indicatorData" :rules="[{ required: true, message: '请输入' }]">
        <CosTextarea :maxlength="2000" placeholder="请输入" v-model:value="dataForm.indicatorData" :view="view" />
      </dc-form-item>

      <dc-form-item :span="12" label="进度和行为活动" name="process" :rules="[{ required: true, message: '请输入' }]">
        <CosTextarea :maxlength="2000" placeholder="请输入" v-model:value="dataForm.process" :view="view" />
      </dc-form-item>
      <dc-form-item label="附件上传" name="fileId" :span="24">
        <UploadFile v-model:value="dataForm.fileId" valueType="array" :view="view" />
      </dc-form-item>
    </dc-layout-card> -->

    <!-- <dc-layout-card title="行动计划" :span="6">
      <dc-form-item :span="12" label="行动方案" name="actionPlan" :rules="[{ required: true, message: '请输入' }]">
        <CosTextarea :maxlength="2000" placeholder="请输入" v-model:value="dataForm.actionPlan" :view="view" />
      </dc-form-item>

      <dc-form-item :span="12" label="目标设定" name="target" :rules="[{ required: true, message: '请输入' }]">
        <CosTextarea :maxlength="2000" placeholder="请输入" v-model:value="dataForm.target" :view="view" />
      </dc-form-item>

      <dc-form-item :span="12" label="目标客户">
        <CosTextarea :maxlength="2000" placeholder="请输入" v-model:value="dataForm.targetCustomer" :view="view" />
      </dc-form-item>

      <dc-form-item :span="12" label="备注">
        <CosTextarea :maxlength="2000" placeholder="请输入" v-model:value="dataForm.remark" :view="view" />
      </dc-form-item>
      <dc-form-item label="抄送人" name="ccTo">
        <UserSelect permission v-model:value="dataForm.ccTo" mode="multiple" :view="view" />
      </dc-form-item>
    </dc-layout-card> -->

    <dc-layout-card
      title="回顾"
      :span="6"
      v-if="props.type === 'review' || (dataForm.reviewTime !== undefined && dataForm.reviewTime !== null)"
    >
      <dc-form-item label="回顾时间" name="reviewTime" :rules="[{ required: true, message: '请输入' }]">
        <!-- <CosSingleDateTimePicker v-model:startTime="dataForm.reviewTime" defaultValue="now" :disabled="true" :isRange="false"  /> -->
        <CosSingleDateTimePicker
          defaultValue="now"
          v-model:startTime="dataForm.reviewTime"
          :disabled="true"
          :isRange="false"
          :view="(view && props.type === 'comment') || props.type === 'view'"
        />
      </dc-form-item>
      <a-col :span="12" />
      <dc-form-item :span="12" label="行动结果" name="actionResult" :rules="[{ required: true, message: '请输入' }]">
        <CosTextarea
          :maxlength="2000"
          placeholder="请输入"
          v-model:value="dataForm.actionResult"
          :view="(view && props.type === 'comment') || props.type === 'view'"
        />
      </dc-form-item>

      <dc-form-item :span="12" label="执行结果" name="executionResult" :rules="[{ required: true, message: '请输入' }]">
        <CosTextarea
          :maxlength="2000"
          placeholder="请输入"
          v-model:value="dataForm.executionResult"
          :view="(view && props.type === 'comment') || props.type === 'view'"
        />
      </dc-form-item>
    </dc-layout-card>
  </a-form>

  <cos-footer-button v-model:value="dataForm" :formRef="formRef">
    <a-button
      type="primary"
      v-if="props.type === 'add' || props.type === 'edit' || props.type === 'review'"
      @click="handleSubmit()"
      :loading="loading"
      v-permission="permissionPage.save"
      >保存</a-button
    >
    <a-button
      type="primary"
      v-if="props.type === 'view' && dataForm.status !== 2"
      @click="editRow"
      v-permission="'lbu_sale_skills_coaching_edit_btn'"
    >
      编辑
    </a-button>
    <a-button
      v-if="props.type === 'view' && dataForm.status !== 2"
      @click="confirmRow"
      v-permission="'lbu_sale_skills_coaching_confirm_btn'"
    >
      确认
    </a-button>
    <a-button
      v-if="
        props.type === 'view' &&
        dataForm.status === 2 &&
        !dataForm.actionResult &&
        shareInfo.getUserInfo().work_code === dataForm.mentor
      "
      @click="reviewRow"
      v-permission="'lbu_sale_skills_coaching_review_btn'"
    >
      回顾
    </a-button>
    <a-button
      v-if="props.type === 'view' && dataForm.status === 2"
      @click="commentRow"
      v-permission="'lbu_sale_skills_coaching_comment_btn'"
    >
      评论
    </a-button>
  </cos-footer-button>
</template>

<script setup lang="ts">
import { shareInfo } from '@dc-platform/dc-interaction'
import CosSingleDateTimePicker from '@/components/CosSingleDateTimePicker/index.vue'
import type { FormInstance } from 'ant-design-vue'
import { ref, computed, onMounted, watch } from 'vue'
import UploadFile from '@/components/UploadFile'
import CustomerAreaCascader from '@/components/CustomerAreaCascader/index.vue'
import { fetchUsersByWorkCode, listByParamCodes } from '@/api/common'
import ClueAndCustomerSelect from '@/components/ClueAndCustomerSelect/index.vue'

import {
  salesSkillsCoachingCreate,
  salesSkillsCoachingDetail,
  salesSkillsCoachingUpdate,
  salesSkillsCoachingReview,
  salesSkillsCoachingConfirm
} from '@/api/yuntuSales/salesSkillsCoaching'

import { DcMessage, DcConfirm } from '@dc-platform/dc-components'
import { goBack } from '@/hooks/cosRouter'
import dayjs from 'dayjs'
import { useRouter, useRoute } from 'vue-router'

import { getFollowListByRefId } from '@/api/yuntuSales/superivisorAccompanyingVisit'

import { paramCodesDataFilter } from '@/utils'
import { followRecordsDetail } from '@/api/yuntuSales/followUpManage'

const router = useRouter()

const dataForm = ref<any>({})
const formRef = ref<FormInstance>()
const loading = ref(false)
const route = useRoute()
const props = defineProps({
  value: Object,
  isEdit: {
    type: Boolean,
    required: true
  },
  view: {
    type: Boolean
  },
  type: {
    type: String,
    required: true,
    validator(value: string) {
      return ['add', 'edit', 'comment', 'review', 'view'].includes(value)
    }
  }
})

const handleCustomerNameChange = (value?: any) => {
  if (value === undefined) {
    followList.value = []
    selectedFollow.value = undefined
    dataForm.value.followId = undefined
  }
}

watch(
  () => dataForm.value.cosId,
  (val) => {
    if (val) {
      fetchFollowList()
    }
  },
  { immediate: true }
)

const followList = ref<any[]>([])
const selectedFollow = ref<any>({})

// 获取跟进记录列表
const fetchFollowList = async () => {
  getFollowListByRefId(dataForm.value.cosId).then((res) => {
    followList.value = res.data
  })
}

const changeFollow = (v: any) => {
  if (v) {
    selectedFollow.value = followList.value.find((item) => item.id === v)
    selectedFollow.value.followMode = paramCodeData.value.lbu_follow_mode.find(
      (item) => item.id === selectedFollow.value.mode
    )?.name
  } else {
    selectedFollow.value = {}
    dataForm.value.followId = undefined
  }
}

const paramCodeData = ref<{
  lbu_follow_mode: []
  lbu_follow_purpose: []
}>({
  lbu_follow_mode: [], // 拜访方式
  lbu_follow_purpose: [] // 访客目的
})
// 获取业务参数
const getByParamCodes = () => {
  listByParamCodes({
    appId: 'cos_lbu',
    paramCodes: ['lbu_follow_mode', 'lbu_follow_purpose']
  }).then((res) => {
    if (res.code === 200) {
      if (props.view) {
        paramCodeData.value = {
          ...res.data
        }
      } else {
        // 递归过滤业务参数状态
        res.data = paramCodesDataFilter(res.data, 0)
        paramCodeData.value = {
          ...res.data
        }
      }
    }
  })
}

onMounted(() => {
  fetch()
  getByParamCodes()
})

const permissionPage = computed(() => {
  if (props.type === 'add') {
    return { save: 'lbu_sale_skills_coaching_add_btn' }
  } else if (props.type === 'edit') {
    return { save: 'lbu_sale_skills_coaching_edit_btn' }
  } else if (props.type === 'review') {
    return { save: 'lbu_sale_skills_coaching_review_btn' }
  } else {
    return {}
  }
})
const emit = defineEmits(['update:detail', 'getDetail'])
const fetch = () => {
  if (route.query.id) {
    loading.value = true
    salesSkillsCoachingDetail({ id: route.query.id })
      .then((res) => {
        if (props.type === 'review') {
          if (!res.data.reviewTime) {
            res.data.reviewTime = dayjs().format('YYYY/MM/DD HH:mm:ss')
          }
        }

        dataForm.value = res.data ? res.data : {}
        fetchFollowList()
        if (dataForm.value.followId) {
          fetchFollowDetail(dataForm.value.followId)
        }
        emit('getDetail', res.data)
      })
      .finally(() => {
        loading.value = false
      })
  }
}

// 获取跟进记录详情
const fetchFollowDetail = async (id: any) => {
  followRecordsDetail(id).then((res) => {
    const followDetail = res.data
    if (followDetail) {
      selectedFollow.value = followDetail
      selectedFollow.value.followMode = paramCodeData.value.lbu_follow_mode.find(
        (item) => item.id === selectedFollow.value.mode
      )?.name
    }
  })
}

const handleMentorChange = (val: any) => {
  if (val && props.type === 'add') getFollowerInfo(val)
}

const handleTraineeChange = (val: any) => {
  if (val && props.type === 'add') {
    const employeeList = [val]
    fetchUsersByWorkCode({ employeeList }).then((res) => {
      const [followerInfo] = res.data
      if (followerInfo && followerInfo.lbuCustomerRegion != null) {
        dataForm.value.traineeRegion = followerInfo.lbuCustomerRegion
      } else {
        dataForm.value.traineeRegion = undefined
        setTimeout(() => formRef.value?.clearValidate('traineeRegion'))
      }
    })
  }
}

const handleFollowClick = () => {
  if (!props.view) {
    return
  }

  router.push({
    path: '/lbu/followUpRecord/view',
    query: {
      id: dataForm.value.followId
    }
  })
}

const getFollowerInfo = (workCode: string) => {
  const employeeList = [workCode]
  fetchUsersByWorkCode({ employeeList }).then((res) => {
    const [followerInfo] = res.data
    if (followerInfo && followerInfo.lbuCustomerRegion != null) {
      dataForm.value.mentorRegion = followerInfo.lbuCustomerRegion
    } else {
      dataForm.value.mentorRegion = undefined
      setTimeout(() => formRef.value?.clearValidate('mentorRegion'))
    }

    if (followerInfo && followerInfo.managerNo != null) {
      dataForm.value.ccTo = [`${followerInfo.managerNo}`]
    }
  })
}

const confirmRow = () => {
  DcConfirm.warning({
    title: '操作提示！',
    content: '是否确认此操作？',
    cancelText: '取消',
    okText: '继续',
    onOk() {
      salesSkillsCoachingConfirm({ id: route.query.id }).then(() => {
        DcMessage.success('操作成功')
        goBack()
      })
    }
  })
}

const reviewRow = () => {
  router.push({
    path: '/lbu/saleCoaching/review',
    query: {
      id: route.query.id
    }
  })
}

const commentRow = () => {
  router.push({
    path: '/lbu/saleCoaching/comment',
    query: {
      id: route.query.id
    }
  })
}

const editRow = () => {
  router.push({
    path: '/lbu/saleCoaching/edit',
    query: {
      id: route.query.id
    }
  })
}

const handleSubmit = async () => {
  formRef.value?.validate().then(async () => {
    loading.value = true
    const p = {
      ...dataForm.value
    }
    try {
      if (props.type === 'edit') {
        await salesSkillsCoachingUpdate(p)
        DcMessage.success('编辑成功')
      } else if (props.type === 'add') {
        await salesSkillsCoachingCreate(p)
        DcMessage.success('新增成功')
      } else if (props.type === 'review') {
        await salesSkillsCoachingReview(p)
        DcMessage.success('回顾成功')
      }
      goBack()
    } catch (error) {}
    loading.value = false
  })
}
</script>
